import { Injectable, Inject } from '@angular/core';
import { UtilitiesService } from '../services/utilities.service';
import { DOCUMENT } from '@angular/common';
import { ONLYNUMBERS } from './regex-base';

const prepositions = /^(da|de|di|do|du)$/i;

interface ICustomString extends String {
    equals: any;
}

@Injectable({providedIn: 'root'})
export class TextUtils {

    constructor(
        private uts: UtilitiesService,
        @Inject( DOCUMENT ) private dom: Document,
    ) { }

    public searchTerms(term, text) {
        return RegExp('\\b' + this.uts
            .removeAccents(term) + '\\b')
            .test(this.uts.removeAccents(text));
    }

    /**
     * Copia uma string para a área de transferência
     * @param value valor a ser copiado
     */
    public copyToClipboard(value: string ): Promise<any> {

        const promise = new Promise(
            (resolve, reject): void => {

                let textarea = null;

                try {

                    // In order to execute the "Copy" command, we actually have to have
                    // a "selection" in the currently rendered document. As such, we're
                    // going to inject a Textarea element and .select() it in order to
                    // force a selection.
                    // --
                    // NOTE: This Textarea is being rendered off-screen.
                    textarea = this.dom.createElement('textarea');
                    textarea.style.height = '0px';
                    textarea.style.left = '-100px';
                    textarea.style.opacity = '0';
                    textarea.style.position = 'fixed';
                    textarea.style.top = '-100px';
                    textarea.style.width = '0px';
                    this.dom.body.appendChild( textarea );

                    // Set and select the value (creating an active Selection range).
                    textarea.value = value;
                    textarea.select();

                    // Ask the browser to copy the current selection to the clipboard.
                    this.dom.execCommand('copy');

                    resolve( value );

                } finally {

                    // Cleanup - remove the Textarea from the DOM if it was injected.
                    if (textarea && textarea.parentNode) {
                        textarea.parentNode.removeChild( textarea );
                    }
                }
            },
        );

        return (promise) ;

    }

    /**
     * Realiza o pad right de uma string
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd (MODIFICADO)
     *
     * @param value string a ser tratada
     * @param targetLength tamanho total esperado
     * @param padString string a ser usada para alcaçar o tamanho total
     */
    public padEnd(value: string, targetLength: number, padString: string = '0') {

        if (!value || value.length >= targetLength) return value;

        // tslint:disable-next-line:no-bitwise
        targetLength = targetLength >> 0; // floor if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));

        if (value.length > targetLength) {
            return String(value);
        } else {

            targetLength = targetLength - value.length;

            // Append to original to ensure we are longer than needed
            if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);

            return String(value) + padString.slice(0, targetLength);

        }
    }

    public padStart(value: string, pad, length) {
        return (new Array(length + 1).join(pad) + value).slice(-length);
    }

    /**
     * Extende o protótipo String com os método adicionais
     */
    public extendStringPrototype() {

        // Extensões de protótipo
        String.prototype.equals = function(value) {
            return value ? this.valueOf() === value.valueOf() : false;
        };

        String.prototype.getOnlyNumbers = function() {
            return this.valueOf()
                .replace(ONLYNUMBERS, '');
        };

        String.prototype.getDateISO = function(skipTime = true) {
            try {

                // Converte formatdo da data de: dd/MM/yyy para: yyy-MM-dd
                const dateRaw = this.valueOf()
                    .split('/')
                    .reverse()
                    .join('-');

                // Gera uma nova data ISO com base na string formatada
                const date = new Date(dateRaw).toISOString();

                // Retorna a ISO completa ou remove a hora da string
                return skipTime ? date.split('T')[0] : date;

            } catch (err) {
                return null;
            }
        };

        (String.prototype as any).getFormatedDate = function() {
            return UtilitiesService.getFormattedDate(this);
        };
    }

    /**
     * Realiza capitalize de cada palavra na string com exceção das preposições
     * @param value string a ser captalizada
     */
    public captalizeEveryWord(value: string) {
        const slices = `${value}`.split(' ');
        return slices
            .map((word) => {
                if (!word.match(prepositions)) {
                    return this.capitalizeWord(word);
                }

                return `${word}`.toLocaleLowerCase();
            })
            .join(' ');
    }
    /**
     * Realiza capitalize de uma palavra
     * @param word palavra a ser capitalizada
     */
    public capitalizeWord(word: string) {
        return word.charAt(0)
            .toUpperCase() + word.slice(1)
            .toLocaleLowerCase();
    }

}
